import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function FeaturesShortsPage() {
  const shortScripts = [
    {
      title: "Crossroads",
      year: "2018",
      image: "https://static.readdy.ai/image/ad65b144d099927d3f1598dca8778b1e/5e570722c6a8d15b8ec9bf156be81de7.png",
      description: "The short script that inspired \"The Perfect Cut.\"",
      copyright: "© 2026 Pamela Stovall",
      awards: [
        "Moondance International Film Festival, Winner of the Spirit Award, Best Short Screenplay",
        "Page International Screenwriting Awards, The Top 25 Scripts, Shorts",
        "Poppy Jasper Film Festival, Winner of the Second Place Award, Best Short Screenplay",
        "Great Lakes Film Festival, Finalist for Best Short Screenplay"
      ]
    },
    {
      title: "Best Served Cold",
      year: "2018",
      image: "https://public.readdy.ai/ai/img_res/3b184932d56be98a0b627023d70e7bf1.jpg",
      description: "When an insecure woman travels to New Mexico to visit her fiancé for a surprise Valentine's Day visit, she discovers more than romance.",
      copyright: "© 2026 Pamela Stovall",
      awards: [
        "Golden Brads of Movie Script Short Script Contest, Top 150 Scripts, Best Short Screenplay",
        "Poppy Jasper Film Festival, Winner of the Third Place Award, Best Short Screenplay",
        "American Gem Short Scripts Contest, Top 100 Scripts of 1,200 scripts"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center">
        <div className="absolute inset-0">
          <img 
            src="https://static.readdy.ai/image/ad65b144d099927d3f1598dca8778b1e/34eadb7562b9326bd001adade0d554bd.png"
            alt="Features & Shorts"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        
        <div className="relative z-10 text-center px-6">
          <h1 className="text-5xl md:text-6xl font-light text-white tracking-tight">Features & Shorts</h1>
          <p className="text-xl text-white/90 mt-4 font-light">Award-winning Screenplays</p>
        </div>
      </section>

      {/* Feature Film Scripts Section */}
      <section className="py-24 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-semibold text-black mb-16 tracking-tight text-center">Feature Film Scripts</h2>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            {/* Images Column */}
            <div className="space-y-8">
              {/* Single Combined Image */}
              <div className="w-full">
                <img 
                  src="https://static.readdy.ai/image/ad65b144d099927d3f1598dca8778b1e/4cd5275312c2a464bb264d5162e25d60.png"
                  alt="The Perfect Cut"
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>

            {/* Content */}
            <div>
              <h3 className="text-4xl font-light text-black mb-6 tracking-tight">The Perfect Cut</h3>
              
              {/* Quote */}
              <div className="bg-gray-50 p-6 mb-8">
                <p className="text-sm text-gray-500 mb-2 tracking-wide">PEOPLE TALKING ABOUT THE PERFECT CUT...</p>
                <p className="text-base text-gray-800 leading-relaxed italic mb-2">
                  "Unique concept. Well paced with lots of reveals and twists."
                </p>
                <p className="text-sm text-gray-600">
                  — Matt Dy, Austin Film Festival Screenplay & Teleplay Competition Director
                </p>
              </div>

              {/* Logline */}
              <div className="mb-8">
                <h4 className="text-lg font-medium text-black mb-3 tracking-wide">LOGLINE</h4>
                <p className="text-gray-700 text-base leading-relaxed">
                  A highly successful jewel thief steals a priceless red diamond but she's caught by a ruthless bounty hunter. The movie starts sixteen years later. She gets out of prison and goes after the diamond again, hoping to use it as bait for the bounty hunter so she can kill him. The robbery goes bad, but she escapes, only to find a sixteen-year-old grifter dogging her trail. The jewel thief goes on the run from the authorities, the bounty hunter, and the girl, who turns out to be her daughter, who grew up in foster homes and is planning her own revenge.
                </p>
                <p className="text-sm text-gray-500 mt-3">© 2026 Pamela Stovall</p>
              </div>

              {/* Awards */}
              <div>
                <h4 className="text-lg font-medium text-black mb-4 tracking-wide">AWARDS</h4>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <span className="text-black mr-3 flex-shrink-0">•</span>
                    <span className="text-gray-700 text-sm leading-relaxed">
                      Final Round, Top 50 Scripts of almost 4,000 scripts, The Writers Lab, New York Women in Film & Television
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-black mr-3 flex-shrink-0">•</span>
                    <span className="text-gray-700 text-sm leading-relaxed">
                      Chosen by BlackShirtReads for a professional screenplay reading at the Jean Cocteau Cinema in Santa Fe, New Mexico
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-black mr-3 flex-shrink-0">•</span>
                    <span className="text-gray-700 text-sm leading-relaxed">
                      Austin Film Festival, Top Ten Percent, "Esteemed Second Rounders"
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-black mr-3 flex-shrink-0">•</span>
                    <span className="text-gray-700 text-sm leading-relaxed">
                      Moondance International Film Festival, 2011, Winner of the Spirit Award, Feature Screenplays
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-black mr-3 flex-shrink-0">•</span>
                    <span className="text-gray-700 text-sm leading-relaxed">
                      Page International Screenwriting Awards, Top Twenty-five Percent, Round Two
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Short Film Scripts Section */}
      <section className="py-24 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-semibold text-black mb-16 tracking-tight text-center">Short Film Scripts</h2>
          
          {/* Crossroads */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-24">
            <div>
              <div className="w-full flex items-center justify-center">
                <img 
                  src={shortScripts[0].image}
                  alt={shortScripts[0].title}
                  className="max-w-full h-auto"
                />
              </div>
            </div>
            
            <div>
              <h3 className="text-4xl font-light text-black mb-6 tracking-tight">{shortScripts[0].title}</h3>
              <p className="text-gray-700 text-base leading-relaxed mb-4">{shortScripts[0].description}</p>
              <p className="text-sm text-gray-500 mb-8">{shortScripts[0].copyright}</p>
              
              <div>
                <h4 className="text-lg font-medium text-black mb-4 tracking-wide">AWARDS</h4>
                <ul className="space-y-3">
                  {shortScripts[0].awards.map((award, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="text-black mr-3 flex-shrink-0">•</span>
                      <span className="text-gray-700 text-sm leading-relaxed">{award}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Best Served Cold */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div className="order-2 md:order-1">
              <h3 className="text-4xl font-light text-black mb-6 tracking-tight">{shortScripts[1].title}</h3>
              <p className="text-gray-700 text-base leading-relaxed mb-4">{shortScripts[1].description}</p>
              <p className="text-sm text-gray-500 mb-8">{shortScripts[1].copyright}</p>
              
              <div>
                <h4 className="text-lg font-medium text-black mb-4 tracking-wide">AWARDS</h4>
                <ul className="space-y-3">
                  {shortScripts[1].awards.map((award, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="text-black mr-3 flex-shrink-0">•</span>
                      <span className="text-gray-700 text-sm leading-relaxed">{award}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="order-1 md:order-2">
              <div className="w-full h-[500px] bg-gray-200 flex items-center justify-center">
                <img 
                  src={shortScripts[1].image}
                  alt={shortScripts[1].title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Festival Recognition Section */}
      <section className="py-24 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-semibold text-black mb-6 tracking-tight text-center">Festival Recognition</h2>
          <p className="text-gray-600 text-center mb-16 max-w-2xl mx-auto">
            Pamela's screenplays have been recognized at prestigious film festivals and competitions worldwide.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Moondance International Film Festival */}
            <div className="bg-gray-50 p-8 text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-4xl text-black"></i>
              </div>
              <h3 className="text-lg font-medium text-black mb-2">Moondance International Film Festival</h3>
              <p className="text-sm text-gray-600">Spirit Award Winner</p>
              <p className="text-xs text-gray-500 mt-2">Feature & Short Screenplays</p>
            </div>

            {/* Austin Film Festival */}
            <div className="bg-gray-50 p-8 text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-film-line text-4xl text-black"></i>
              </div>
              <h3 className="text-lg font-medium text-black mb-2">Austin Film Festival</h3>
              <p className="text-sm text-gray-600">Top Ten Percent</p>
              <p className="text-xs text-gray-500 mt-2">"Esteemed Second Rounders"</p>
            </div>

            {/* Page International */}
            <div className="bg-gray-50 p-8 text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-trophy-line text-4xl text-black"></i>
              </div>
              <h3 className="text-lg font-medium text-black mb-2">Page International Screenwriting Awards</h3>
              <p className="text-sm text-gray-600">Top 25 Scripts</p>
              <p className="text-xs text-gray-500 mt-2">Shorts Category</p>
            </div>

            {/* Poppy Jasper Film Festival */}
            <div className="bg-gray-50 p-8 text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-medal-line text-4xl text-black"></i>
              </div>
              <h3 className="text-lg font-medium text-black mb-2">Poppy Jasper Film Festival</h3>
              <p className="text-sm text-gray-600">2nd & 3rd Place Winner</p>
              <p className="text-xs text-gray-500 mt-2">Best Short Screenplay</p>
            </div>

            {/* The Writers Lab */}
            <div className="bg-gray-50 p-8 text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-quill-pen-line text-4xl text-black"></i>
              </div>
              <h3 className="text-lg font-medium text-black mb-2">The Writers Lab</h3>
              <p className="text-sm text-gray-600">Final Round, Top 50</p>
              <p className="text-xs text-gray-500 mt-2">NY Women in Film & Television</p>
            </div>

            {/* Great Lakes Film Festival */}
            <div className="bg-gray-50 p-8 text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-star-line text-4xl text-black"></i>
              </div>
              <h3 className="text-lg font-medium text-black mb-2">Great Lakes Film Festival</h3>
              <p className="text-sm text-gray-600">Finalist</p>
              <p className="text-xs text-gray-500 mt-2">Best Short Screenplay</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 px-6 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-light text-black mb-6 tracking-tight">Interested in These Scripts?</h2>
          <p className="text-gray-700 text-base mb-8 leading-relaxed">
            For inquiries about any of these screenplays please contact Pamela Stovall.
          </p>
          <a 
            href="/contact"
            className="inline-block px-8 py-3 bg-black text-white text-sm font-medium tracking-wide hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Contact Pamela
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
